import React, { useState } from "react";
import "./Slideshow.css";
import { slideData } from "../../assets/data/slideData";
import { Carousel } from "react-bootstrap";

function ControlledCarousel() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel activeIndex={index} onSelect={handleSelect} className="slider">
      {slideData.map((item, index) => {
        return (
          <Carousel.Item key={index}>
            <div className="slider-text">
              <p>{item.description}</p>
              <h5>{item.title}</h5>
            </div>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

export default ControlledCarousel;
